import { ToggleSwitchDesignTokens } from '@primeng/themes/types/toggleswitch';

interface ICustomToggleSwitchDesignTokens extends ToggleSwitchDesignTokens {
  handle: ToggleSwitchDesignTokens['handle'] & {
    shadow: string;
  };
  small: {
    width: string;
    height: string;
    gap: string;
    handle: {
      size: string;
    };
  };
}

export const baseToggleswitchToken: ICustomToggleSwitchDesignTokens = {
  root: {
    width: '1.625rem',
    height: '0.875rem',
    borderRadius: '1.8125rem',
    gap: '1px',
    // shadow: '{form.field.shadow}',
    focusRing: {
      //   width: '{focus.ring.width}',
      //   style: '{focus.ring.style}',
      //   color: '{focus.ring.color}',
      offset: '1px',
      //   shadow: '{focus.ring.shadow}',
    },
    // borderWidth: '1px',
    // borderColor: 'transparent',
    // hoverBorderColor: 'transparent',
    // checkedBorderColor: 'transparent',
    // checkedHoverBorderColor: 'transparent',
    // invalidBorderColor: '{form.field.invalid.border.color}',
    // transitionDuration: '{form.field.transition.duration}',
    // slideDuration: '0.2s',
  },
  handle: {
    // borderRadius: '50%',
    size: '0.75rem',
    shadow: '0px 2.4px 4.8px 0px #00000040',
  },
  // it's custom property
  small: {
    width: '1.25rem',
    height: '0.75rem',
    gap: '0.0625rem',
    handle: {
      size: '0.625rem',
    },
  },
  colorScheme: {
    light: {
      root: {
        background: '{gray.100}',
        // disabledBackground: '{form.field.disabled.background}',
        hoverBackground: '{gray.100}',
        checkedBackground: '{blue.300}',
        checkedHoverBackground: '{blue.300}',
      },
      handle: {
        background: 'linear-gradient(180deg, #FFFFFF 0%, #C5C5C5 100%);',
        // disabledBackground: '{form.field.disabled.color}',
        hoverBackground: 'linear-gradient(180deg, #FFFFFF 0%, #C5C5C5 100%);',
        checkedBackground: 'linear-gradient(180deg, #C4E0EF 0%, #B2C6D1 100%)',
        checkedHoverBackground: 'linear-gradient(180deg, #C4E0EF 0%, #B2C6D1 100%)',
        // color: '{text.muted.color}',
        // hoverColor: '{text.color}',
        // checkedColor: '{primary.color}',
        // checkedHoverColor: '{primary.hover.color}',
      },
    },
    // dark: {
    //   root: {
    //     background: '{surface.700}',
    //     disabledBackground: '{surface.600}',
    //     hoverBackground: '{surface.600}',
    //     checkedBackground: '{primary.color}',
    //     checkedHoverBackground: '{primary.hover.color}',
    //   },
    //   handle: {
    //     background: '{surface.400}',
    //     disabledBackground: '{surface.900}',
    //     hoverBackground: '{surface.300}',
    //     checkedBackground: '{surface.900}',
    //     checkedHoverBackground: '{surface.900}',
    //     color: '{surface.900}',
    //     hoverColor: '{surface.800}',
    //     checkedColor: '{primary.color}',
    //     checkedHoverColor: '{primary.hover.color}',
    //   },
    // },
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-toggleswitch {
      display: inline-flex;
    }

    .p-toggleswitch-handle {
        box-shadow: ${dt('toggleswitch.handle.shadow')};
    }

    .png-small.p-toggleswitch {
      --p-toggleswitch-width: ${dt('toggleswitch.small.width')};
      --p-toggleswitch-height: ${dt('toggleswitch.small.height')};
      --p-toggleswitch-gap: ${dt('toggleswitch.small.gap')};
      --p-toggleswitch-handle-size: ${dt('toggleswitch.small.handle.size')};
    }
    `,
};
